import {
  AUDIT_ROUTES,
  auditErrorSummaryResponseSchema,
  auditListResponseSchema,
  securityBlockLiftResponseSchema,
  securityBlockListResponseSchema,
  type AuditErrorSummary,
  type AuditErrorSummaryQuery,
  type AuditList,
  type AuditQuery,
  type SecurityBlockList,
  type SecurityBlockQuery,
} from "@nh/shared";
import { authFetch } from "@/shared/api/session";

/**
 * El cliente de la Bitácora: cuatro llamadas, todas de super admin, todas
 * validadas contra el contrato compartido. Las rutas YA traen `/api`, por
 * eso el `baseUrl` vacío — el mismo patrón que Soporte y Usuarios.
 */
const NO_PREFIX = { baseUrl: "" } as const;

/** Solo viajan los filtros que traen valor: una cadena vacía no es un filtro. */
function toParams(query: Record<string, string | number | undefined>): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === "") continue;
    params.set(key, String(value));
  }
  return params.toString();
}

export function listAudit(query: AuditQuery): Promise<AuditList> {
  return authFetch(`${AUDIT_ROUTES.list}?${toParams(query)}`, auditListResponseSchema, NO_PREFIX);
}

export function getErrorSummary(query: AuditErrorSummaryQuery): Promise<AuditErrorSummary> {
  return authFetch(
    `${AUDIT_ROUTES.errorSummary}?${toParams(query)}`,
    auditErrorSummaryResponseSchema,
    NO_PREFIX,
  );
}

export function listBlocks(query: SecurityBlockQuery): Promise<SecurityBlockList> {
  return authFetch(
    `${AUDIT_ROUTES.blocks}?${toParams(query)}`,
    securityBlockListResponseSchema,
    NO_PREFIX,
  );
}

export function liftBlock(id: string): Promise<{ lifted: true }> {
  return authFetch(AUDIT_ROUTES.block(id), securityBlockLiftResponseSchema, {
    ...NO_PREFIX,
    method: "DELETE",
  });
}
